module.exports = __webpack_public_path__ + "media/images/new_home/review-border-8d24940c49b15e3642b0b6317deb32f9.png";